import { ATTRIBUTION_NAMES, ROLES, type ATTRIBUTION } from "@/constants/User";
import type { UserAttributions } from "@/schemas/User";

export function isAdmin(attributions: UserAttributions): boolean {
	return attributions.some((a) => a.name === ATTRIBUTION_NAMES.ADMIN);
}

export function isResponsible(
	role: string,
	attributions: UserAttributions,
): boolean {
	return (
		attributions.some((a) => a.name === ATTRIBUTION_NAMES.ORGANIZACAO) &&
		role === ROLES.RESP
	);
}

export function hasAttribution(
	attributions: UserAttributions,
	attributionName: ATTRIBUTION,
): boolean {
	return attributions.some((a) => a.name === attributionName);
}
